<template>
  <v-app id="ictp" :class="'navOpen'">
    <NavigationDrawer v-if="$route.meta.navigation"/>

    <AppBar
      title="ICT PLUS"
      v-if="$route.meta.navigation"
    />

    <v-main>
      <v-container fluid>
        <v-fade-transition mode="out-in">
          <router-view/>
        </v-fade-transition>
        <IdleWarning ref="idleWarning"></IdleWarning>
        <SplashPage ref="splashPage"></SplashPage>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import AppBar from "./AppBar";
  import NavigationDrawer from "./NavigationDrawer";
  import IdleWarning from "./errors/IdleWarning";
  import {HEARTBEAT_EXEMPTIONS} from '../constants';
  import SplashPage from "./SplashPage";
  import {mapState} from 'vuex';

  export default {
    name: 'App',
    components: {
      NavigationDrawer,
      AppBar,
      IdleWarning,
      SplashPage
    },
    created() {
      this.$eventHub.$on('tokenNearlyExpired', this.openIdleWarning);
    },
    methods: {
      openIdleWarning() {
        console.log('openIdleWarning');
        const routeName = this.$route.name;
        console.log('routName:' + routeName);
        if (this.$store.state.auth.token && !HEARTBEAT_EXEMPTIONS.find(item => item === routeName)) {
          const refs = this.$refs;
          const idleWarning = refs.idleWarning;
          if (!idleWarning.isOpened()) {
            idleWarning.open();
          }
        }
      },
      openSplashPage() {
        const splashStatus = sessionStorage.getItem('ictp-splash-page-status');
        const refs = this.$refs;
        const splashPage = refs.splashPage;
        if (this.$store.state.auth.token && !splashPage.isOpened() && splashStatus !== 'read') {
          splashPage.open();
        }
      }
    },
    computed: {
      ...mapState({
        site_code: s => s.school.selected ? s.school.selected.site_code : ''
      }),
    },
    watch: {
      site_code: function (newValue, oldValue){
        if(newValue !== oldValue) {
          this.$ga.set('userId', `sitecode:${newValue}`);
        }
      }
    },
    mounted() {
      if (this.claims && this.claims.sitecodes) {
        const siteCodes = this.claims.sitecodes;
        if (Array.isArray(siteCodes) && siteCodes.length > 0) {
          if (siteCodes.indexOf('*') === -1) {
            const defaultSiteCode = siteCodes[0];
            this.$ga.set('userId', `sitecode:${defaultSiteCode}`);
          }
        }
      }
      setTimeout(() => {
        this.openSplashPage();
      }, 3000);
    }
  };
</script>
<style lang="scss" scoped>
 #ictp > div.v-application--wrap > header {
    z-index: 1000;
 }

 ::v-deep .v-content__wrap{
   background:#F4F4F7;
 }
 
 ::v-deep .contentHeading{
   padding:0 80px;
 }

 ::v-deep .contentSpacer{
   padding:0 92px;
 }

.navOpen ::v-deep .contentHeading{
     padding:0 8px;
 }

 .navOpen ::v-deep .contentSpacer{
     padding:0 20px;
 }
</style>